<app-main-navigation></app-main-navigation>
<div class="container">

<div class="row">
    <div class="col-12">

        <nav *ngIf="user">
            <ol class="breadcrumb  mt-2  mb-2  pl-0  pb-0" style="background-color: transparent;">
                <li class="breadcrumb-item"><a routerLink="/">Dashboard</a></li>
                <li class="breadcrumb-item"><a routerLink="/indstillinger">Indstillinger</a></li>
                <li class="breadcrumb-item  active"><a routerLink="/users">Users</a></li>
                <li class="breadcrumb-item  active">Edit user</li>
            </ol>
        </nav>


        <div class="row mt-3">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body">
                        <ng-container *ngIf="!user">
                            <h6 class="text-muted">Loading user...</h6>

                            <div class="progress" style="height: 10px;">
                                <div class="progress-bar  progress-bar-striped  progress-bar-animated"
                                     role="progressbar"
                                     style="width: 100%; background-color: rgba(127,127,127,0.98);"></div>
                            </div>
                        </ng-container>

                        <ng-container *ngIf="user">
                            <form #userForm="ngForm" novalidate autocomplete="off">
                                <div class="mb-3">
                                    <label for="password" i18n>Name</label>
                                    <input type="text" class="form-control"
                                           [(ngModel)]="user.name" name="name"
                                           [ngClass]="{'is-invalid': userForm.form.hasError('invalid', 'name')}"
                                    >
                                    <div class="invalid-feedback" *ngIf="userForm.form.hasError('invalid', 'name')">
                                        {{userForm.form.getError('invalid', 'name')}}
                                    </div>
                                </div>

                                <div class="mb-3">
                                    <label for="password" i18n>Username / Email</label>
                                    <input type="email" class="form-control" [(ngModel)]="user.username" name="username"
                                           autocomplete="new-password"
                                           [ngClass]="{'is-invalid': userForm.form.hasError('invalid', 'username')}"
                                    >
                                    <div class="invalid-feedback" *ngIf="userForm.form.hasError('invalid', 'username')">
                                        {{userForm.form.getError('invalid', 'username')}}
                                    </div>
                                </div>

                                <div class="mb-3">
                                    <label>Group:</label>
                                    <select class="form-select"
                                            [(ngModel)]="user.group_id" name="group_id"
                                            [ngClass]="{'is-invalid': userForm.form.hasError('invalid', 'group_id')}"
                                    >
                                        <option *ngFor="let group of groups"
                                                [value]="group.id">{{group.name}}</option>
                                    </select>
                                    <div class="invalid-feedback" *ngIf="userForm.form.hasError('invalid', 'group_id')">
                                        {{userForm.form.getError('invalid', 'group_id')}}
                                    </div>

                                </div>

                                <div class="mb-3">
                                    <label for="password" i18n>New password</label>
                                    <input type="password" class="form-control"
                                           [(ngModel)]="user.password" name="password"
                                           [ngClass]="{'is-invalid': userForm.form.hasError('invalid', 'password')}"
                                           autocomplete="new-password"
                                    >
                                    <div class="invalid-feedback" *ngIf="userForm.form.hasError('invalid', 'password')">
                                        {{userForm.form.getError('invalid', 'password')}}
                                    </div>
                                </div>
                                <div class="mb-3">
                                    <label for="password_confirm" i18n>Repeat new password</label>
                                    <input type="password" class="form-control"
                                           [(ngModel)]="user.password_confirm" name="password_confirm"
                                           [ngClass]="{'is-invalid': userForm.form.hasError('invalid', 'password_confirm')}"

                                    >
                                    <div class="invalid-feedback"
                                         *ngIf="userForm.form.hasError('invalid', 'password_confirm')">
                                        {{userForm.form.getError('invalid', 'password_confirm')}}
                                    </div>
                                </div>

                                <div>
                                    <ng-container *ngFor="let custom_field of user.custom_fields">
                                         <ng-container *ngIf="custom_field.field_type ==='select'">
                                                <div class="mb-3">
                                                    <label> {{custom_field.name}}</label>
                                                    <select class="form-select" [(ngModel)]="custom_field.value" name="task" [ngModelOptions]="{standalone: true}">
                                                        <option *ngFor="let option of custom_field.options" [value]="option.value">{{option.name}}</option>
                                                    </select>
                                                </div>
                                            </ng-container>
                                            <ng-container *ngIf="custom_field.field_type === 'multiselect'">
                                                <div class="mb-3">
                                                    <label> {{custom_field.name}}</label>
                                                    <ng-multiselect-dropdown
                                                        [placeholder]="'Vælg sikkerhedsikon(er)'"
                                                        [settings]="dropdownSettings"
                                                        [data]="custom_field.options"
                                                        [(ngModel)]="multiSelectSelection"
                                                        (onSelect)="onSelect($event)"
                                                        (onDeSelect)="onDeSelect($event)"
                                                        (onSelectAll)="onSelectAll($event)"></ng-multiselect-dropdown>
                                                </div>
                                            </ng-container>

                                            <ng-container *ngIf="custom_field.field_type ==='checkbox'">
                                                <div class="form-check" *ngIf="custom_field.name">
                                                    <label class="form-check-label">
                                                        <input class="form-check-input" type="checkbox"
                                                               [ngModel]="custom_field.value==1?true:false"
                                                               (ngModelChange)="custom_field.value=$event?1:0"
                                                               [ngModelOptions]="{standalone: true}">
                                                        {{custom_field.name}}
                                                    </label>
                                                </div>
                                            </ng-container>

                                            <ng-container *ngIf="custom_field.field_type ==='text'">
                                                <div class="mb-3"><label class="form-label"> {{custom_field.name}}</label>
                                                    <input type="text" class="form-control" [(ngModel)]="custom_field.value" [name]="'field-'+custom_field.id">
                                                </div>
                                            </ng-container>
                                    </ng-container>

                                    <div class="mb-3" *ngFor="let permission of user.permissions">
                                        <div class="form-check">
                                            <label class="form-check-label">
                                                <input class="form-check-input" type="checkbox"
                                                       [ngModel]="permission.allowed?true:false"
                                                       (ngModelChange)="permission.allowed=$event?1:0"
                                                       [ngModelOptions]="{standalone: true}">
                                                {{ permission.aco.alias }}
                                            </label>
                                        </div>

                                    </div>
                                </div>

                                <button (click)="save()" type="submit" class="btn  btn-primary  float-end  mt-3 mb-5"
                                        [disabled]="saving">{{ saving ?
                                    'Working...' : 'Save' }}
                                </button>
                            </form>
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</div>
